<template>
  <b-container fluid class="pt-4 gradient">
    <b-row align-h="center" class="full-height">
      <b-col md="6" lg="4">
        <b-card>
          <div class="text-center pt-2 pb-4">
            <img class="logo" src="/img/new-logo.svg" />
          </div>
          <h2 class="text-sm-center" v-if="!activated">Activate your account</h2>
          <b-button size="lg" block variant="primary" @click="activate" v-if="!activated && !activationError">
            <strong>Activate</strong>
          </b-button>
          <b-alert variant="danger" class="text-center" :show="activationError">Activation link invalid</b-alert>

          <h2 class="text-sm-center" v-if="activated">Activation successful</h2>
          <p class="card-text text-sm-center" v-if="activated">
            Your account is activated!
            <br />You can now login with your chosen credentials.
          </p>

          <b-row slot="footer">
            <b-col>
              <router-link :to="{ name: 'login' }">Login</router-link>
            </b-col>
            <b-col class="text-sm-right">
              <router-link :to="{ name: 'signup' }" class="pull-right">Signup</router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script type="text/javascript">
export default {
  data: () => ({
    activated: false,
    activationError: false
  }),
  methods: {
    activate() {
      let creds = this.$route.query
      this.$emit('activate', creds)
      this.$store
        .dispatch('activate', creds)
        .then(() => {
          this.activated = true
        })
        .catch(() => {
          this.activationError = true
        })
    }
  },
  mounted() {
    this.activate()
  }
}
</script>
